export const downloadFile = ({ urlFile, name }) => {
    const link = document.createElement('a')
    link.href = urlFile
    link.target = '_blank'
    link.download = name
    link.click()

    URL.revokeObjectURL(urlFile)
}